export default {
  tab: {
    overview: 'Overview',
    performance: 'Performance',
    proportion: 'Proportion',
    fmi: 'FMI',
    investor: 'Statistic by Investor',
  },

  indexSummary: {
    totalVolume: 'Total Volume: ',
    totalValue: 'Total Value: ',
    bnVnd: 'Bn. VND',
  },
  sectorSummary: {
    totalMatchVolume: 'Total Match Volume: ',
    totalMatchValue: 'Total Match Value: ',
    bnVnd: 'Bn. VND',
  },
};
